var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.column === "category"
        ? [
            _vm._v(
              " " + _vm._s(_vm.item.category && _vm.item.category.name) + " "
            ),
          ]
        : _vm.column === "subcategory"
        ? [
            _vm._v(
              " " +
                _vm._s(_vm.item.subcategory && _vm.item.subcategory.name) +
                " "
            ),
          ]
        : _vm.column === "type"
        ? [_vm._v(" " + _vm._s(_vm.item.type && _vm.item.type.name) + " ")]
        : _vm.column === "guid"
        ? [_vm._v(" " + _vm._s(_vm.item.serialNumber) + " ")]
        : _vm.column === "name"
        ? [_vm._v(" " + _vm._s(_vm.item.name) + " ")]
        : _vm.column === "holder"
        ? [
            _c(
              "a",
              {
                attrs: {
                  href: `?r=redesign#/personal-employee/${_vm.item.holderId}/summary`,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.item.holder))]
            ),
          ]
        : _vm.column === "expiryDate"
        ? [_vm._v(" " + _vm._s(_vm.item.expirationDate) + " ")]
        : _vm.column === "issueDate"
        ? [_vm._v(" " + _vm._s(_vm.item.issueDate) + " ")]
        : _vm.column === "files"
        ? [
            _vm.item.files.length
              ? _c(
                  "div",
                  {
                    staticClass: "files",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("showFiles", _vm.item)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.item.filesLabel) + " ")]
                )
              : _vm._e(),
          ]
        : _vm.column === "cost"
        ? [
            _vm.item.cost
              ? _c("div", { staticClass: "cost" }, [
                  _vm._v(" " + _vm._s(_vm.item.cost.toLocaleString()) + " "),
                ])
              : _vm._e(),
          ]
        : _vm.column === "manufactureDate"
        ? [_vm._v(" " + _vm._s(_vm.item.productionDate) + " ")]
        : _vm.column === "purchaseDate"
        ? [_vm._v(" " + _vm._s(_vm.item.purchaseDate) + " ")]
        : _vm.column === "model"
        ? [_vm._v(" " + _vm._s(_vm.item.model) + " ")]
        : _vm.column === "purchasePlace"
        ? [_vm._v(" " + _vm._s(_vm.item.purchasePlace) + " ")]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }